import { render, staticRenderFns } from "./ProductInfoPage.vue?vue&type=template&id=35403a6a&scoped=true&"
import script from "./ProductInfoPage.vue?vue&type=script&lang=js&"
export * from "./ProductInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoPage.vue?vue&type=style&index=0&id=35403a6a&scoped=true&lang=css&"
import style1 from "./ProductInfoPage.vue?vue&type=style&index=1&id=35403a6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35403a6a",
  null
  
)

export default component.exports